import type { JSX } from 'react';

import classNames from 'classnames';

import { Highlight } from './Highlight';

import styles from './RecordSearch.module.css';

export interface SearchMatch {
  field: string;
  value: string;
  fuzzy: boolean;
  exact?: boolean;
}

interface MatchedOnProps {
  match: SearchMatch | null | undefined;
  query: string;
  /** Hide the value when it is already the row's title (a name matched on name). */
  hideValueWhen?: string | null;
  className?: string;
}

/** "Email · jane@acme.com" — which field a search result matched, with the match in bold. */
export function MatchedOn({
  match,
  query,
  hideValueWhen,
  className,
}: MatchedOnProps): JSX.Element | null {
  if (!match) return null;
  const showValue = !hideValueWhen || match.value.trim() !== hideValueWhen.trim();
  return (
    <span className={classNames(styles.MatchedOn, className)}>
      <span className={styles.MatchedField}>
        {match.fuzzy ? `${match.field}, close match` : match.field}
      </span>
      {showValue && (
        <span className={styles.MatchedValue}>
          {match.fuzzy ? match.value : <Highlight text={match.value} query={query} />}
        </span>
      )}
    </span>
  );
}
